@if (navigatieVoorkeurService.nieuweNavigatie()) {
	<app-selection-bar [showSelection]="isSelectionVisible()">
		<app-dashboard-acties [shareVisible]="true" [exportVisible]="true" (exportClicked)="startExport($event)"></app-dashboard-acties>
	</app-selection-bar>
	<app-tab-menu></app-tab-menu>
} @else {
	<app-user-tab-menu (exportClicked)="startExport()" [exportVisible]="true" [shareVisible]="true"></app-user-tab-menu>
	<app-selection-bar [showTerug]="from !== undefined" [terugPageNiet]="getUrlPart()" [showSelection]="isSelectionVisible()"></app-selection-bar>
}
<div class="sidebar">
	<div class="titlebar">
		<h3>{{ title() }}</h3>
	</div>
	<app-instant-search-box (fire)="searchInput$.next($event)"></app-instant-search-box>
	<app-lijst
		(nextPage)="fetch$.emit($event)"
		(selectedChange)="selectElement($event)"
		[elementen]="elementen()"
		[getData]="getLijstElementData"
		[selected]="selectedLijstElement()"
	></app-lijst>
</div>
<main>
	<app-detail-panel
		(changeElement)="changeElement$.emit($event)"
		[detailsData]="detailsData()"
		[showNext]="showNext()"
		[showPrevious]="showPrevious()"
		[type]="getType()"
		data-exportable
	></app-detail-panel>
	<app-click-blocking-overlay
		[enabled]="(filterService.filterPanelOpened$ | async) ?? false"
		(clicked)="filterService.filterPanelOpened$.next(false)"
	></app-click-blocking-overlay>
	<div [class.show-sidebar]="filterService.filterPanelOpened$ | async" class="dashboard">
		<div class="spinner-overlay">
			@if (showSpinner$ | async) {
				<app-svg-spinner></app-svg-spinner>
			}
		</div>
		<router-outlet (activate)="onActivate($event)"></router-outlet>
	</div>
</main>
